import { useState, useEffect, useContext } from "react";

import { ThemeContext } from "styled-components";

export default function useWindowSize() {
  const themeContext = useContext(ThemeContext);

  // Given "1200px", return 1200
  const depxify = (breakpoint) => {
    return parseInt(breakpoint, 10);
  };

  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  // Breakpoints:
  // sm = 640px
  // md = 1040px

  // isDesktop 1040px+
  const isDesktop = () => {
    return windowSize.width >= depxify(themeContext.breakpoints.md);
  };

  // isTablet 640px - 1039px
  const isTablet = () => {
    return (
      windowSize.width >= depxify(themeContext.breakpoints.sm) &&
      windowSize.width < depxify(themeContext.breakpoints.md)
    );
  };

  // isMobile 0 - 639px
  const isMobile = () => {
    return windowSize.width < depxify(themeContext.breakpoints.sm);
  };

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return { windowSize, isDesktop, isTablet, isMobile };
}
